<template>
  <v-app
    v-if="lpuAddressList.length || isVisibleOtherCountriesOfWork"
    :class="{
      'px-2 pt-2': externalDataStore.isMobile,
    }"
  >
    <div
      id="doctor-page-lpu-list"
      class="rounded doctor-page-lpu-list--redesign doctor-page-lpu-list"
      :class="{ 'pa-2': externalDataStore.isMobile }"
    >
      <DoctorPageLpuListHeader v-if="lpuAddressList.length" />
      <DoctorPageLpuListBody />
    </div>
  </v-app>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { dispatchCustomEventGlobally } from 'www/utils'
import type {
  Doctor,
  LpuAddressList,
  OtherCountryOfWork,
  SynonymPriceList,
  Urls,
} from 'www/vue_components/common/DoctorPageLpuList/types'
import { initPopupContent } from 'www/vue_components/common/BannerMtLink/functions'
import DoctorPageLpuListHeader from 'www/vue_components/common/DoctorPageLpuList/components/DoctorPageLpuListHeader.vue'
import DoctorPageLpuListBody from 'www/vue_components/common/DoctorPageLpuList/components/DoctorPageLpuListBody.vue'
import { useExternalDataStore } from 'www/vue_components/common/DoctorPageLpuList/stores'

const props = defineProps<{
  currentDate: string
  doctor: Doctor
  lpuAddressList: LpuAddressList
  synonymPriceList: SynonymPriceList
  isAppointmentOn: boolean
  appointmentWillEnableTime: string
  lpuWithAppointmentIds: number[]
  townTranslit: string
  townTimedelta: number | null
  urls: Urls,
  otherCountriesOfWork?: OtherCountryOfWork[]
}>()

const externalDataStore = useExternalDataStore()

externalDataStore.currentDate = props.currentDate
externalDataStore.doctor = props.doctor
externalDataStore.lpuAddressList = props.lpuAddressList
externalDataStore.synonymPriceList = props.synonymPriceList
externalDataStore.isAppointmentOn = props.isAppointmentOn
externalDataStore.appointmentWillEnableTime = props.appointmentWillEnableTime
externalDataStore.lpuWithAppointmentIds = props.lpuWithAppointmentIds
externalDataStore.townTranslit = props.townTranslit
externalDataStore.townTimedelta = props.townTimedelta
externalDataStore.urls = props.urls
externalDataStore.otherCountriesOfWork = props.otherCountriesOfWork || []

const isVisibleOtherCountriesOfWork = Boolean(externalDataStore.otherCountriesOfWork.length)

onMounted(() => {
  dispatchCustomEventGlobally('doctor-page-lpu-list-mounted')

  if (!externalDataStore.isMobile) {
    dispatchCustomEventGlobally('doctor-page-lpu-list:updated')

    initPopupContent()
  }
})
</script>

<style lang="scss">
@import '~www/themes/doctors/common/variables';

.doctor-page-lpu-list {
  border: 2px solid $ui-kit-primary;
  border-radius: $border-radius-md;

  &--redesign {
    & > *:first-child {
      border-top-left-radius: inherit;
      border-top-right-radius: inherit;
    }

    & > *:last-child,
    & > *:last-child > *:last-child {
      border-bottom-left-radius: inherit;
      border-bottom-right-radius: inherit;
    }
  }
}
</style>
